var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typeform-widget",attrs:{"id":"typeform"}},[_c('div',{staticClass:"target-dom-node",style:(("width: 100%; height: " + (_vm.active && !_vm.alreadyAnswerd
				? _vm.$mq.isDesktop()
					? this.height
					: '200px' 
				: '0px') + ";"))})])}
var staticRenderFns = []

export { render, staticRenderFns }